import { memoizeFunction } from '../../Utilities';
import { mergeStyles } from '../../Styling';
export var getClassNames = memoizeFunction(function (className, isDragging) {
    return {
        root: mergeStyles(className, isDragging && {
            touchAction: 'none',
            selectors: {
                '& *': {
                    userSelect: 'none',
                },
            },
        }),
    };
});
//# sourceMappingURL=DraggableZone.styles.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/office-ui-fabric-react/lib/utilities/DraggableZone/DraggableZone.styles.js
// module id = 332
// module chunks = 0